export const environment = {
    production: false,
    apiUrl: 'https://vcpowertune-dev.ddns.net/api/',
    portalUrl: 'https://dev.aitune.pt/',
    isDemo: true,
    defaultDropdownLimit: 50,
    defaultTableSize: 100,
};
